import { mobile } from "../../../mediaQueries"

const styles = theme => ({
    span: {
        flexBasis: '30%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            flexBasis: '100%',
            width: '100%',
            marginBottom: '20px'
        }
    },
    menuItem: {
        fontFamily: 'Aktiv Grotesk',
        fontWeight: 400,
        fontSize: '1rem',
        padding: '12px 1rem'
    },
    menuSelected: {
        backgroundColor: '#0045EA !important',
        color: 'white'
    },
    input: {
        backgroundColor: 'white',
        border: '1px solid rgba(0, 0, 0, 0.5)',
        padding: '14px',
        width: '100%',
        textAlign: 'left',
        '&:focus': {
            backgroundColor: 'white !important'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            width: '100%',
            textAlign: 'left'
        }
    },
    icon: {
        marginLeft: '-32px',
        cursor: 'pointer',
        pointerEvents: 'none',
        height: '24px',
        width: '24px'
    },
    label: {
        margin: '0',
        fontSize: '12px',
        color: '#101010',
        alignSelf: 'flex-start',
        fontFamily: 'Aktiv Grotesk',
        marginBottom: '.5rem',
        fontWeight: '400'
    }
})

export default styles